import React, { lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import RedirectRoute from '../LegacyRedirect/RedirectRoute';
import LoginForm from '../LoginForm/LoginForm';
import Impersonate from '../Impersonate/Impersonate';

import NoMatch from '../NoMatch/NoMatch';
import Profile from '../Profile/Profile';
import { PageSkeleton } from '../ContentSkeleton/ContentSkeleton';
import WebChat from '../WebChat/WebChat';
import PaymentApplication from '../PaymentApplication/PaymentApplication';
import SigningThankYouPage from '../SigningThankYouPage/SigningThankYouPage';

const GuarantorSignatureSuccess = lazy(() => import('../GuarantorSignature/GuarantorSignatureSuccess'));
const AppSubmit = lazy(() => import('../AppSubmit/AppSubmit'));
const GuarantorSignature = lazy(() => import('../GuarantorSignature/GuarantorSignature'));
const ChangePasswordForm = lazy(() => import('../ChangePassword/ChangePasswordForm'));
const Accounts = lazy(() => import('../Accounts/Accounts'));
const Billing = lazy(() => import('../Billing/Billing'));



export default function PrivateRoutes({ disableUserProfile }) {

    return (
        <Suspense fallback={<PageSkeleton/>}>
            <Switch>
                <Route exact path="/" render={(props) => <Accounts {...props} />} />
                <Route path="/impersonate/:token" render={props => <Impersonate {...props} />} />
                <Route path="/ChangePassword" render={props => <ChangePasswordForm  {...props} />} />
                {disableUserProfile ? null : <Route path="/profile" render={props => <Profile {...props} />} />}
                <Route path="/login" render={props => <LoginForm {...props} />} />                <Route exact path="/payment-application" render={(p) => <PaymentApplication {...p} />} />
                <Route path="/accounts" exact render={props => <Accounts {...props} />} />
                <Route path="/accounts/:accountnumber" render={props => <Accounts  {...props} />} />
                <Route path="/billing" exact render={props => <Billing  {...props} />} />
                <Route path="/billing/:accountnumber" render={props => <Billing  {...props} />} />
                <Route path="/submit-application" render={props => <AppSubmit  {...props} />} />
                <Route exact path="/guarantor-signature" render={props => <GuarantorSignature  {...props} />} />
                <Route path="/guarantor-signature-success" render={props => <GuarantorSignatureSuccess  {...props} />} />
                <Route path="/signing-success" render={(p) => <SigningThankYouPage {...p} />} />
                <Route path="/chat" render={props => <WebChat {...props} />} />
                <RedirectRoute path="/user/Home.aspx" />
                <RedirectRoute path="/user/makepayment.aspx" />
                <RedirectRoute path="/user/accountadmin.aspx" />
                <RedirectRoute path="/user/BuyoutQuote.aspx" />
                <RedirectRoute path="/user/PaymentHistory.aspx" />
                <RedirectRoute path="/user/Documents.aspx" />
                <RedirectRoute path="/user/userprofile.aspx" notRelatedToAccount />


                {/* <Route path='/documents' exact component={Documents}/>
          <Route path='/documents/:accountnumber' component={Documents}/>
          <Route path='/documents/:accountnumber/upload' component={Documents} /> */}
                <Route render={props => <NoMatch  {...props} />} /> 
            </Switch>
        </Suspense>
    );
}
